import dateFormat from "dateformat";
export default function dateStringFormatDefault(date) {
  if (!date) {
    return null;
  }
  return dateFormat(date * 1000 - 86400, "dd/mm/yyyy");
}
